<template>
  <ul-page class="page-term-manager">
    <template v-slot:left>
      <div class="page-header-left">
        <div class="page-header-title">{{ $t('pages_textbook_termManager_455') }}</div>
      </div>
    </template>
    <div class="page-content">
      <div class="back-wrapper">
        <div class="back" @click="$router.back()">
          <i class="iconfont icon-shangyige"></i><span>{{ $t('pages_textbook_termManager_456') }}</span>
        </div>
      </div>
      <div class="course-title">{{course.name}}</div>
      <div class="course-url">{{ $t('pages_textbook_termManager_457') }}<a :href="textbookPortalUrl" target="_blank">{{textbookPortalUrl}}</a></div>
      <ul-table class="table-course" border :data="[course]">
        <ul-table-column
          prop="name"
          :label="$t('pages_textbook_termManager_421')"
          >
          <template slot-scope="scope">
            <div class="col-total">
              <div class="">{{ $t('pages_textbook_termManager_458', { var0: scope.row.totalLearnerCount }) }}</div>
              <div class="">{{ $t('pages_textbook_termManager_459', { var0: scope.row.insideLearnerCount }) }}</div>
              <div class="">{{ $t('pages_textbook_termManager_460', { var0: scope.row.outsideLearnerCount }) }}</div>
              <div class="">{{ $t('pages_textbook_termManager_461', { var0: scope.row.socialLearnerCount }) }}</div>
            </div>
          </template>
        </ul-table-column>
        <ul-table-column
          prop="name"
          :label="$t('pages_textbook_termManager_422')"
          width="200px"
          >
          <template slot-scope="scope">
            <div class="school-num">
              <div>{{scope.row.spocOrgCount}}</div>
              <a href="javascript:;" @click="viewSchoolData">{{ $t('pages_textbook_termManager_462') }}</a>
            </div>
          </template>
        </ul-table-column>
        <ul-table-column
          prop="outsideSpocCount"
          :label="$t('pages_textbook_termManager_423')"
          width="200px"
          >
        </ul-table-column>
      </ul-table>
      <div class="portal-tips">{{ $t('pages_textbook_termManager_463') }}</div>
      <div class="section section-version">
        <div class="section-header">
          <div class="section-title">{{ $t('pages_textbook_termManager_464') }}</div>
          <ul-button hollow @click="toTextbookLib">{{ $t('pages_textbook_termManager_465') }}</ul-button>
          <ul-button type="primary" @click="addNewVersion">{{ $t('pages_textbook_termManager_466') }}</ul-button>
        </div>
        <div class="section-tips">
          {{ $t('pages_textbook_termManager_467') }}
        </div>
        <ul-table class="table-version" border :data="versionList">
        <ul-table-column
          :label="$t('pages_textbook_termManager_424')"
          prop="index"
          width="80px"
          >
        </ul-table-column>
        <ul-table-column
          prop="courseId"
          label="ID"
          width="120px"
          >
        </ul-table-column>
        <ul-table-column
          prop="courseName"
          :label="$t('pages_textbook_termManager_425')"
          >
        </ul-table-column>
        <ul-table-column
          :label="$t('pages_textbook_termManager_426')"
          width="200px"
          >
          <template  slot-scope="scope">
            <span>{{scope.row.createTime | formatDate}}</span>
          </template>
        </ul-table-column>
        <ul-table-column
          :label="$t('pages_textbook_termManager_427')"
          width="200px"
          >
          <template  slot-scope="scope">
            <span>{{scope.row.updateTime | formatDate}}</span>
          </template>
        </ul-table-column>
        <ul-table-column
          :label="$t('pages_textbook_termManager_428')"
          width="120px"
          >
          <template  slot-scope="scope">
            <span v-if="scope.row.isOriginCourse">-</span>
            <a href="javascript:;" v-else @click="deleteVersion(scope.row)">{{ $t('pages_textbook_termManager_468') }}</a>
          </template>
        </ul-table-column>
      </ul-table>
      </div>
      <div class="section section-term">
        <div class="section-header">
          <div class="section-title">{{ $t('pages_textbook_termManager_469') }}</div>
          <ul-button type="primary" @click="addNewTerm">{{ $t('pages_textbook_termManager_470') }}</ul-button>
        </div>
        <div class="section-tips">
          {{ $t('pages_textbook_termManager_471') }}
        </div>
        <ul-table class="table-version" border :data="termList">
          <ul-table-column
            :label="$t('pages_textbook_termManager_429')"
            width="80px"
            >
            <template  slot-scope="scope">
              <span>{{termList.length - scope.$index}}</span>
            </template>
          </ul-table-column>
          <ul-table-column
            prop="time"
            :label="$t('pages_textbook_termManager_430')"
            width="300px"
            >
            <template  slot-scope="scope">
              <span>{{getTermTime(scope.row)}}</span>
              <!-- <span>{{scope.row.startTime | formatDate}}</span> -->
            </template>
          </ul-table-column>
          <ul-table-column
            prop="courseName"
            :label="$t('pages_textbook_termManager_431')"
            >
            <template slot-scope="scope">
            {{termStatusMap[scope.row.status]}}
            </template>
          </ul-table-column>
          <ul-table-column
            prop="studentNum"
            :label="$t('pages_textbook_termManager_432')"
            width="150px"
            >
          </ul-table-column>
          <ul-table-column
            :label="$t('pages_textbook_termManager_433')"
            width="250px"
            >
            <template  slot-scope="scope">
              <a class="btn-link" href="javascript:;" @click="showTermData(scope.row, termList.length - scope.$index)">{{ $t('pages_textbook_termManager_472') }}</a>
              <a class="btn-link" href="javascript:;" @click="modifyTerm(scope.row)">{{ $t('pages_textbook_termManager_473') }}</a>
              <a class="btn-link" href="javascript:;" @click="deleteTerm(scope.row)">{{ $t('pages_textbook_termManager_474') }}</a>
              <a class="btn-link" href="javascript:;" @click="enterClass(scope.row)">{{ $t('pages_textbook_termManager_475') }}</a>
            </template>
          </ul-table-column>
        </ul-table>
      </div>
      <div class="learner-count">
        {{ $t('pages_textbook_termManager_476', { var0: course.selfLearnerCount || 0 }) }}
      </div>
    </div>
    <!-- <ul-dialog
      :title="$t('pages_textbook_termManager_434')"
      class="dialog-version"
      width="800px"
      @open="getOriginTextbookList"
      :visible.sync="versionDialogVisiable">
      <div class="textbook-area">
        <ul-input
          class="search-group"
          :placeholder="$t('pages_textbook_termManager_435')"
          clearable
          suffix-icon="icon-quanshipei-sousuo"
          search
          @search="getOriginTextbookList"
          @keydown.native.enter="getOriginTextbookList"
          v-model="originKeyword">
        </ul-input>
        <ul class="origin-textbooks-list">
          <li v-for="(item,index) in originTextbookList" :key="index">
            <ul-checkbox v-model="versionIds" :label="item.courseId" :disabled="item.allowfreedomreg != 1 || !!item.declareCourseId">
              <div class="radio-content">
                <span class="title">{{item.name}}</span>
                <span class="status" v-if="item.allowfreedomreg == 1">{{ $t('pages_textbook_termManager_477', { var0: item.courseId, var1: item.createTime | formatDate }) }}</span>
                <span class="status" v-if="item.allowfreedomreg == 0">{{ $t('pages_textbook_termManager_478') }}</span>
              </div>
            </ul-checkbox>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitNewVersion">{{ $t('pages_textbook_termManager_479') }}</ul-button>
        <ul-button plain @click="versionDialogVisiable = false">{{ $t('pages_textbook_termManager_480') }}</ul-button>
      </span>
    </ul-dialog> -->
    <ul-dialog
      :title="$t('pages_textbook_termManager_436')"
      class="dialog-version"
      width="800px"
      @open="getOriginTextbookList"
      :visible.sync="versionDialogVisiable">
      <div class="textbook-area">
        <ul-input
          class="search-group"
          :placeholder="$t('pages_textbook_termManager_437')"
          clearable
          suffix-icon="icon-quanshipei-sousuo"
          search
          @search="getOriginTextbookList"
          @keydown.native.enter="getOriginTextbookList"
          v-model="originKeyword">
        </ul-input>
        <ul class="origin-textbooks-list">
          <li v-for="(item,index) in originTextbookList" :key="index">
            <ul-checkbox v-model="versionIds" :label="item.courseId" :disabled="item.allowfreedomreg != 1 || !!item.declareCourseId">
              <div class="radio-content">
                <span class="title">{{item.name}}</span>
                <span class="status" v-if="item.allowfreedomreg == 1">{{ $t('pages_textbook_termManager_481', { var0: item.courseId, var1: item.createTime | formatDate }) }}</span>
                <span class="status" v-if="item.allowfreedomreg == 0">{{ $t('pages_textbook_termManager_482') }}</span>
              </div>
            </ul-checkbox>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitNewVersion">{{ $t('pages_textbook_termManager_483') }}</ul-button>
        <ul-button plain @click="versionDialogVisiable = false">{{ $t('pages_textbook_termManager_484') }}</ul-button>
      </span>
    </ul-dialog>
    <ul-dialog
      :title="$t('pages_textbook_termManager_438')"
      class="dialog-term"
      width="800px"
      @opened="dialogTermOpened"
      @open="getOcList"
      :visible.sync="termDialogVisiable">
      <ul-form ref="termForm" :model="term" :rules="rules" label-width="auto">
        <ul-form-item prop="time" class="form-item-time" :label="$t('pages_textbook_termManager_439')">
          <ul-date-picker type="date" format="yyyy-MM-dd" value-format="timestamp" v-model="term.startTime" :placeholder="$t('pages_textbook_termManager_440')"></ul-date-picker>
          <span class="split">{{ $t('pages_textbook_termManager_485') }}</span>
          <ul-date-picker type="date" format="yyyy-MM-dd" value-format="timestamp" v-model="term.endTime" :placeholder="$t('pages_textbook_termManager_441')"></ul-date-picker>
        </ul-form-item>
        <ul-form-item prop="textbookId" :label="$t('pages_textbook_termManager_442')">
          <ul-select v-model="term.textbookId" :placeholder="$t('pages_textbook_termManager_443')">
            <ul-option v-for="item in versionList" :key="item.id" :value="item.courseId" :label="item.courseName"></ul-option>
          </ul-select>
        </ul-form-item>
        <ul-form-item prop="ocIds" :label="$t('pages_textbook_termManager_444')" class="form-item-origin">
          <div class="tips">{{ $t('pages_textbook_termManager_486') }}</div>
          <div class="select-resource-div">
            <dl>
              <dd @click="selectType(1)" :class="{'select-dd':activeName==1}">{{ $t('pages_textbook_termManager_487') }}</dd>
              <dd @click="selectType(2)" :class="{'select-dd':activeName==2}">{{ $t('pages_textbook_termManager_488') }}</dd>
            </dl>
          </div>
          <ul-checkbox-group v-model="term.ocIds">
            <ul-table class="table-course" border :data="termOcList">
              <ul-table-column
                prop="name"
                :label="$t('pages_textbook_termManager_445')"
                >
                <template slot-scope="scope">
                  <ul-checkbox :label="scope.row.ocId" :disabled="!!scope.row.associated && term.id != scope.row.associated">
                    <span>{{scope.row.ocName}}</span>
                  </ul-checkbox>
                </template>
              </ul-table-column>
              <ul-table-column
                v-if="activeName == 2"
                prop="orgName"
                :label="$t('pages_textbook_termManager_446')"
                width="160px"
                >
              </ul-table-column>
              <ul-table-column
                prop="teacherName"
                :label="$t('pages_textbook_termManager_447')"
                width="100px"
                >
              </ul-table-column>
              <ul-table-column
                prop="userCount"
                :label="$t('pages_textbook_termManager_448')"
                width="100px"
                >
              </ul-table-column>
              <ul-table-column
                prop="createTime"
                :label="$t('pages_textbook_termManager_449')"
                width="160px"
                >
                <template slot-scope="scope">
                  <span>{{scope.row.createTime | formatDate}}</span>
                </template>
              </ul-table-column>
            </ul-table>
          </ul-checkbox-group>
        </ul-form-item>
      </ul-form>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitTerm">{{ $t('pages_textbook_termManager_489') }}</ul-button>
        <ul-button plain @click="termDialogVisiable = false">{{ $t('pages_textbook_termManager_490') }}</ul-button>
      </span>
    </ul-dialog>
    <ul-dialog
      ::title="$t('pages_textbook_termManager_450')"
      class="dialog-term-data"
      width="800px"
      :visible.sync="termDataDialogVisiable">
     <ul>
      <li>
        <div class="data-label">{{ $t('pages_textbook_termManager_491') }}</div>
        <div class="data-content">
          <div class="data-item">{{ $t('pages_textbook_termManager_492', { var0: termStat.videoCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_493', { var0: termStat.videoLength }) }}</div>
        </div>
      </li>
      <li>
        <div class="data-label">{{ $t('pages_textbook_termManager_494') }}</div>
        <div class="data-content">
          <div class="data-item">{{ $t('pages_textbook_termManager_495', { var0: termStat.graphicPageCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_496', { var0: termStat.notVideoResourceCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_497', { var0: termStat.ocContentCount }) }}</div>
        </div>
      </li>
      <li>
        <div class="data-label">{{ $t('pages_textbook_termManager_498') }}</div>
        <div class="data-content">
          <div class="data-item">{{ $t('pages_textbook_termManager_499', { var0: termStat.announcementCount }) }}</div>
        </div>
      </li>
      <li>
        <div class="data-label">{{ $t('pages_textbook_termManager_500') }}</div>
        <div class="data-content">
          <div class="data-item">{{ $t('pages_textbook_termManager_501', { var0: termStat.homeworkCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_502', { var0: termStat.homeworkQuestionCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_503', { var0: termStat.homeworkLearnerCount }) }}</div>
        </div>
      </li>
      <li>
        <div class="data-label">{{ $t('pages_textbook_termManager_504') }}</div>
        <div class="data-content">
          <div class="data-item">{{ $t('pages_textbook_termManager_505', { var0: termStat.discussionCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_506', { var0: termStat.discussionTeacherActionCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_507', { var0: termStat.discussionJoinerCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_508', { var0: termStat.discussionPostCount }) }}</div>
        </div>
      </li>
      <li>
        <div class="data-label">{{ $t('pages_textbook_termManager_509') }}</div>
        <div class="data-content">
          <div class="data-item">{{ $t('pages_textbook_termManager_510', { var0: termStat.examCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_511', { var0: termStat.examQuestionCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_512', { var0: termStat.examJoinerCount }) }}</div>
          <div class="data-item">{{ $t('pages_textbook_termManager_513', { var0: termStat.examPassCount }) }}</div>
        </div>
      </li>
     </ul>
     <div class="tips">{{ $t('pages_textbook_termManager_514') }}</div>
    </ul-dialog>
    <ul-dialog
      :title="$t('pages_textbook_termManager_451')"
      class="dialog-school-data"
      width="800px"
      :visible.sync="schoolDataDialogVisiable">
        <div class="total-num">{{ $t('pages_textbook_termManager_515', { var0: course.spocOrgCount }) }}</div>
        <ul-table class="table-course" border :data="course.spocOrgList">
          <ul-table-column
            prop="orgName"
            :label="$t('pages_textbook_termManager_452')">
          </ul-table-column>
          <ul-table-column
            prop="spocCount"
            :label="$t('pages_textbook_termManager_453')"
            width="200px"
            >
          </ul-table-column>
          <ul-table-column
            prop="studentCount"
            width="150px"
            :label="$t('pages_textbook_termManager_454')">
          </ul-table-column>
        </ul-table>
      </ul-dialog>
  </ul-page>
</template>

<script>
import { getDeclareCourseInfo,
         getDeclareCourseVersion,
         getDeclareCourseTerm,
         getDeclareOriginTextbookList,
         addDeclareCourseVersion,
         deleteDeclareCourseVersion,
         getDeclareCourseOcList,
         saveDeclareCourseTerm,
         deleteDeclareCourseTerm,
         getDeclareCourseTermStat,
         getCourseMenu,
         getCourseOcListOtherOrg
        } from '@/api/courseApi'
import formateDate from '@/mixins/formatDate.js'
import { formatDate } from '@/utils'
import { COURSE_WEB_HOST, UA_WEB_HOST, UMOOC_SERVER_HOST } from '@/config'
export default {
  name: 'page-term-manager',
  mixins: [formateDate],
  data () {
    return {
      course: {},
      versionList: [],
      termList: [],
      versionDialogVisiable: false,
      originKeyword: '',
      originTextbookList: [],
      versionIds: [],
      term: { ocIds: [] },
      termDialogVisiable: false,
      termOcList: [],
      formatDate: formatDate,
      termStatusMap: {
        '1': this.$t('pages_textbook_termManager_516'),
        '2': this.$t('pages_textbook_termManager_517'),
        '3': this.$t('pages_textbook_termManager_518')
      },
      termDataDialogVisiable: false,
      termStat: {},
      currentStatTermNum: '',
      schoolDataDialogVisiable: false,
      activeName: 1
    }
  },
  computed:{
    courseId () {
      return this.$route.query.courseId
    },
    rules () {
      let rules = {
        time: [ 
          // {
          //   required: true, message: '请选择开始时间', trigger: 'blur'
          // },
          { validator: (rule, value, callback) => {
            if (!this.term.startTime) {
              return callback(new Error(this.$t('pages_textbook_termManager_519')));
            }
            if (!this.term.endTime) {
              return callback(new Error(this.$t('pages_textbook_termManager_520')));
            }
            if (this.term.endTime < this.term.startTime) {
              return callback(new Error(this.$t('pages_textbook_termManager_521')));
            }
            callback();
          }, trigger: 'change' }
        ],
        textbookId: [
          { required: true, message: this.$t('pages_textbook_termManager_522'), trigger: 'change' }
        ],
        ocIds: [
          { required: true, message: this.$t('pages_textbook_termManager_523'), trigger: 'change' }
        ]
      }
      return rules
    },
    textbookPortalUrl () {
      return `${UMOOC_SERVER_HOST}/course/${this.course.courseId}`
    }
  },
  created () {
    window.test = this
    this.getDeclareCourseInfo()
    this.getDeclareCourseVersion()
    this.getDeclareCourseTerm()
  },
  methods: {
    selectType (type) {
      this.activeName = type
      if (type == 1) {
        this.getOcList()
      } else {
        this.otherClass()
      }
    },
    otherClass () {
      getCourseOcListOtherOrg(this.courseId)
      .then(({result}) => {
        this.termOcList = result
        console.log(result)
      })
    },
    enterClass (row) {
      this.term = {...this.term, ...row}
      getDeclareCourseOcList(this.courseId)
      .then(({result}) => {
        let list = []
        result.forEach(item => {
          if (this.term.id == item.associated && this.term.ocIds.indexOf(item.ocId) != -1) {
            list.push(item)
          }
        })
        getCourseOcListOtherOrg(this.courseId)
        .then(({result}) => {
          result.forEach(item => {
            if (this.term.id == item.associated && this.term.ocIds.indexOf(item.ocId) != -1) {
              list.push(item)
            }
          })
          let ocId = null
          if (list.length == 1) {
            ocId = list[0].ocId
          } else if (list.length > 1) {
            let data = this.getMax(list)
            ocId = data.ocId
          }

          if (ocId) {
            getCourseMenu(ocId)
            .then(({result}) => {
              console.log(result)
              let hash = ''
              let menuId = 1
              let arr = result.filter(item => item.isHomepage)
              if (arr.length > 0) {
                menuId = arr[0].id
              }
              switch (menuId) {
                case 1:
                  hash = 'announcement'
                  break;
                case 2:
                  hash = 'textbook'
                  break;
                case 3:
                  hash = 'resource'
                  break;
                case 4:
                  hash = 'homework'
                  break;
                case 5:
                  hash = 'discussion'
                  break;
                case 6:
                  hash = 'classroom'
                  break;
                case 7:
                  hash = 'live'
                  break;
                case 8:
                  hash = 'exam'
                  break;
                case 18:
                  hash = 'units'
                  break;
                case 19:
                  hash = 'knowledgeGraph'
                  break;
                default:
                  hash = 'announcement'
              }
              window.open(`${COURSE_WEB_HOST}/ulearning/index.html#/course/${hash}?courseId=${ocId}`)
            })
          }
        })
      })
    },
    getMax(data) {
      let max = data[0];
      for (let i = 1; i < data.length; i++){
        if (data[i].userCount > max.userCount) {
          max = data[i];
        }
      }
      return max;
    },
    getDeclareCourseInfo () {
      getDeclareCourseInfo(this.courseId)
        .then(({result}) => {
          this.course = result
          // this.course.spocOrgList = [
          //   {
          //     orgName: '武汉工程大学',
          //     spocCount: 12,
          //     studentCount: 22
          //   },
          //   {
          //     orgName: '武汉工程大学',
          //     spocCount: 12,
          //     studentCount: 22
          //   },
          //   {
          //     orgName: '武汉工程大学',
          //     spocCount: 12,
          //     studentCount: 22
          //   }
          // ]
        })
    },
    getDeclareCourseVersion () {
      getDeclareCourseVersion(this.courseId)
        .then(({result}) => {
            this.versionList = result.map((item, index) => {
              item.index = index + 1
              return item
            })
            this.versionList = this.versionList.reverse()
            this.versionIds = this.versionList.map(item => item.courseId)
        })
    },
    getDeclareCourseTerm () {
      getDeclareCourseTerm(this.courseId)
        .then(({result}) => {
            this.termList = result.map(item => {
              item.textbookId = item.textbookId || ''
              return item
            })
        })
    },
    getOriginTextbookList () {
      getDeclareOriginTextbookList({ courseName: this.originKeyword })
        .then(({result}) => {
          this.originTextbookList = result
        })
    },
    addNewVersion () {
      this.versionDialogVisiable = true
    },
    submitNewVersion () {
      if (this.versionIds.length == 0) {
        return this.$message({
          message: this.$t('pages_textbook_termManager_524'),
          type: 'warning'
        })
      }
      addDeclareCourseVersion({
        declareCourseId: this.courseId,
        courseIds: this.versionIds
      })
        .then(({result}) => {
          this.versionDialogVisiable = false
          this.getDeclareCourseVersion()
        })
    },
    deleteVersion (item) {
      this.$confirm(this.$t('pages_textbook_termManager_525'),this.$t('pages_textbook_termManager_526'))
        .then(() => {
          deleteDeclareCourseVersion(item.id)
            .then(() => {
              this.$message({
                message: this.$t('pages_textbook_termManager_527'),
                type: 'success'
              })
              this.getDeclareCourseVersion()
            })
        })
    },
    getTermTime (item) {
      return formatDate(item.startTime, 'yyyy-MM-dd') + this.$t('pages_textbook_termManager_528') + formatDate(item.endTime, 'yyyy-MM-dd')
    },
    addNewTerm () {
      this.term = { ocIds: [],textbookId: this.versionList[0].courseId }
      // this.term.textbookId = this.versionList[0].courseId
      this.termDialogVisiable = true
    },
    dialogTermOpened () {
      this.$refs['termForm'].clearValidate()
    },
    getOcList () {
      this.activeName = 1
      getDeclareCourseOcList(this.courseId)
        .then(({result}) => {
          console.log(result)
          this.termOcList = result
        })
    },
    submitTerm () {
      this.$refs['termForm'].validate(valid => {
        if (valid) {
         console.log(this.term)
         this.term.declareCourseId = this.courseId
         saveDeclareCourseTerm(this.term)
          .then(({result}) => {
            this.termDialogVisiable = false
            this.getDeclareCourseTerm()
          })
        }
      })
    },
    showTermData (item, num) {
      this.termDataDialogVisiable = true
      this.currentStatTermNum = num
      getDeclareCourseTermStat(item.id)
        .then(({result}) => {
          console.log(result)
          result.videoLength = Math.round(result.videoLength * 10 / 60) / 10
          this.termStat = result
        })
    },
    modifyTerm (item) {
      // item.ocIds = [34502]
      this.term = {...this.term, ...item}
      this.termDialogVisiable = true
    },
    deleteTerm (item) {
      this.$confirm(this.$t('pages_textbook_termManager_529'), this.$t('pages_textbook_termManager_530'))
        .then(() => {
          deleteDeclareCourseTerm(item.id)
            .then(({result}) => {
              this.getDeclareCourseTerm()
            })
        })
    },
    viewSchoolData () {
      this.schoolDataDialogVisiable = true
    },
    toTextbookLib () {
      window.open(`${UA_WEB_HOST}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content{
  padding: 20px;
   .back-wrapper{
    display: flex;
    align-items: center;
    margin-bottom: 6px;
   }
   .back {
    cursor: pointer;
    line-height: 20px;
    i{
      margin-right: 6px;
      color: #cbcbd1;
    }
    &:hover{
      span{
        color: $--color-primary;
      }
    }
  }
  .course-title{
    font-size: 20px;
    font-weight: bold;
  }
  .course-url{
    color: $--color-text-secondary;
  }
  .table-course{
    margin-top: 10px;
  }
  .portal-tips{
    margin-top: 8px;
    color: $--color-primary;
    font-size: 12px;
  }
  .section{
    margin-top: 20px;
    .section-header{
      display: flex;
      align-items: center;
    }
    .section-title{
      flex: 1;
      margin-right: 10px;
      padding: 0px 8px;
      border-left: solid 3px $--color-primary;
      line-height: 1;
      font-size: 16px;
      font-weight: bold;
    }
    .section-tips{
      padding: 8px;
      border-radius: 2px;
      font-size: 12px;
      color: #ce9d2b;
    }
  }
  .section-term{
    .btn-link{
      margin-right: 10px;
    }
  }
  
}
.learner-count {
  // margin-top: 20px;
  padding: 15px 10px;
  border: 1px solid #e3e3e9;
  border-top: none;
}
.dialog-version{
  .search-group {
    width: 300px;
  }
  .ul-checkbox{
    line-height: 36px;
  }
  .origin-textbooks-list{
    min-height: 240px;
    max-height: 360px;
    margin-top: 6px;
    overflow: auto;
  }
  .radio-content{
    display: inline-block;
  }
}
.dialog-term{
  .select-resource-div {
    margin: 0;
    margin-bottom: 16px;
    color: #444;
    font-size: 14px;
    .select-dd {
      color: #ea5947;
      border-bottom: 2px solid #ea5947;
    }
    dl {
      display: flex;
      width: 100%;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.2);
      dd {
        padding: 5px 10px;
        cursor: pointer;
      }
    }
    dl,
    dd {
      margin: 0;
    }
  }
  .split{
    margin: 0 10px;
  }
  .form-item-time{
    ::v-deep {
      .ul-form-item__label{
        &:before{
          content: '*';
          color: #f60000;
          margin-right: 4px;
        }
      }
    }
  }
}
.dialog-term-data{
  ul{
    border: $--border-base;
    li{
      display: flex;
      align-items: center;
      line-height: 24px;
      &:not(:last-child){
        border-bottom: $--border-base;
      }
      .data-label{
        width: 120px;
        padding: 10px 10px;
        
      }
      .data-content{
        width: 0;
        flex: 1;
        padding: 10px 10px;
        border-left: $--border-base;
      }
    }
  }
  .tips{
    color: $--color-primary;
    line-height: 40px;
  }
}
.dialog-school-data{
  .total-num{
    font-weight: bold;
  }
  .ul-table{
    margin: 10px 0;
  }
}
</style>